import { render, staticRenderFns } from "./PrenesiDatoteko.vue?vue&type=template&id=71847c03&"
import script from "./PrenesiDatoteko.vue?vue&type=script&lang=js&"
export * from "./PrenesiDatoteko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports